import {
  AltiusRes,
  IDashboardBenchmarkSummary,
  IDashboardBenchmarkSummaryBody,
  IFeedItem,
  IMarketSignal,
  IPaginationResponse
} from "../../types";
import { IProfileStats } from "../../types/user/social";
import { AsyncActions } from "../base";

export interface IDashboardActions {
  getFeedAction: (params: { type: string; search: string; page: number }) => Promise<IPaginationResponse<IFeedItem>>;
  getDashboardKpiSummary: () => Promise<IProfileStats>;
  getDashboardBenchmarkSummary: (body: IDashboardBenchmarkSummaryBody) => Promise<IDashboardBenchmarkSummary>;
  getDashboardMarketSignals: () => Promise<IMarketSignal[]>;
}

export class DashboardActions extends AsyncActions implements IDashboardActions {
  public getFeedAction: IDashboardActions["getFeedAction"] = async (params) => {
    const {
      data: { data }
    } = await this.api.get<AltiusRes<IPaginationResponse<IFeedItem>>>({
      url: "/api/v0.0.3/user/feed",
      signal: this.addProcess("getFeedAction").signal,
      params
    });
    this.removeProcess("getFeedAction");
    return data;
  };

  public getDashboardKpiSummary: IDashboardActions["getDashboardKpiSummary"] = async () => {
    const {
      data: { data: payload }
    } = await this.api.get<AltiusRes<IProfileStats>>({ url: "api/v0.0.3/dashboard/summary" });
    return payload;
  };

  public getDashboardBenchmarkSummary: IDashboardActions["getDashboardBenchmarkSummary"] = async (body) => {
    const {
      data: { data: payload }
    } = await this.api.post<AltiusRes<IDashboardBenchmarkSummary>>({
      url: "api/v0.0.3/dashboard/benchmark-summary",
      data: body
    });
    return payload;
  };

  public getDashboardMarketSignals: IDashboardActions["getDashboardMarketSignals"] = async () => {
    const {
      data: { data: payload }
    } = await this.api.get<AltiusRes<IMarketSignal[]>>({
      url: "api/v0.0.3/dashboard/market-signals"
    });
    return payload;
  };
}
